export class AnalyticsServiceStub {
    public AppInsights: {
        event: ((name: string, properties?: any, measurements?: any) => any);
    };

    constructor() {
        this.AppInsights = {
            event: this.eventAppInsights,
        };
    }
    private eventAppInsights(name: string, properties?: any, measurements?: any) {

    }
}